import {
  ClaimLinkEditorPageEnum,
  IAddTemplateRequest,
  IClaimLinkBuilderFieldUpdate,
  IClaimLinkBuilderValues,
  IClaimLinkTemplate,
  IClaimLinkTemplateErrors,
  ICreateClaimLinkTemplateResponse,
  IEditTemplateRequest,
  IFetchClaimLinkTemplatesPayload,
  IFetchClaimLinkTemplatesResponse,
  ISaveClaimLinkTemplateRequest,
  IUpdateClaimLinkTemplateDetailsRequest,
  TCollectiveTemplateItem,
  TemplateTypesEnum,
  TemplateValidationModalEnum,
} from '../../types/templates';

export const FETCH_NOTES_TEMPLATES_REQUEST = 'FETCH_NOTES_TEMPLATES_REQUEST';
export const FETCH_NOTES_TEMPLATES_SUCCESS = 'FETCH_NOTES_TEMPLATES_SUCCESS';
export const FETCH_NOTES_TEMPLATES_FAILURE = 'FETCH_NOTES_TEMPLATES_FAILURE';

export const FETCH_EMAILS_TEMPLATES_REQUEST = 'FETCH_EMAILS_TEMPLATES_REQUEST';
export const FETCH_EMAILS_TEMPLATES_SUCCESS = 'FETCH_EMAILS_TEMPLATES_SUCCESS';
export const FETCH_EMAILS_TEMPLATES_FAILURE = 'FETCH_EMAILS_TEMPLATES_FAILURE';

export const FETCH_CLAIM_LINK_TEMPLATES_REQUEST = 'FETCH_CLAIM_LINK_TEMPLATES_REQUEST';
export const FETCH_CLAIM_LINK_TEMPLATES_SUCCESS = 'FETCH_CLAIM_LINK_TEMPLATES_SUCCESS';
export const FETCH_CLAIM_LINK_TEMPLATES_FAILURE = 'FETCH_CLAIM_LINK_TEMPLATES_FAILURE';

export const FETCH_CLAIM_LINK_TEMPLATE_BY_ID_REQUEST = 'FETCH_CLAIM_LINK_TEMPLATE_BY_ID_REQUEST';
export const FETCH_CLAIM_LINK_TEMPLATE_BY_ID_SUCCESS = 'FETCH_CLAIM_LINK_TEMPLATE_BY_ID_SUCCESS';
export const FETCH_CLAIM_LINK_TEMPLATE_BY_ID_FAILURE = 'FETCH_CLAIM_LINK_TEMPLATE_BY_ID_FAILURE';

export const SET_CLAIM_LINK_TEMPLATE_SAVING = 'SET_CLAIM_LINK_TEMPLATE_SAVING';

export const UPDATE_CLAIM_LINK_TEMPLATE_DETAILS_REQUEST = 'UPDATE_CLAIM_LINK_TEMPLATE_DETAILS_REQUEST';
export const UPDATE_CLAIM_LINK_TEMPLATE_DETAILS_SUCCESS = 'UPDATE_CLAIM_LINK_TEMPLATE_DETAILS_SUCCESS';
export const UPDATE_CLAIM_LINK_TEMPLATE_DETAILS_FAILURE = 'UPDATE_CLAIM_LINK_TEMPLATE_DETAILS_FAILURE';

export const ADD_CLAIM_LINK_TEMPLATE_REQUEST = 'ADD_CLAIM_LINK_TEMPLATE_REQUEST';
export const ADD_CLAIM_LINK_TEMPLATE_SUCCESS = 'ADD_CLAIM_LINK_TEMPLATE_SUCCESS';
export const ADD_CLAIM_LINK_TEMPLATE_FAILURE = 'ADD_CLAIM_LINK_TEMPLATE_FAILURE';

export const EDIT_CLAIM_LINK_TEMPLATE_REQUEST = 'EDIT_CLAIM_LINK_TEMPLATE_REQUEST';
export const EDIT_CLAIM_LINK_TEMPLATE_SUCCESS = 'EDIT_CLAIM_LINK_TEMPLATE_SUCCESS';
export const EDIT_CLAIM_LINK_TEMPLATE_FAILURE = 'EDIT_CLAIM_LINK_TEMPLATE_FAILURE';

export const ADD_TEMPLATE_REQUEST = 'ADD_TEMPLATE_REQUEST';
export const ADD_TEMPLATE_SUCCESS = 'ADD_TEMPLATE_SUCCESS';
export const ADD_TEMPLATE_FAILURE = 'ADD_TEMPLATE_FAILURE';

export const EDIT_TEMPLATE_REQUEST = 'EDIT_TEMPLATE_REQUEST';
export const EDIT_TEMPLATE_SUCCESS = 'EDIT_TEMPLATE_SUCCESS';
export const EDIT_TEMPLATE_FAILURE = 'EDIT_TEMPLATE_FAILURE';

export const DELETE_TEMPLATE_REQUEST = 'DELETE_TEMPLATE_REQUEST';
export const DELETE_TEMPLATE_SUCCESS = 'DELETE_TEMPLATE_SUCCESS';
export const DELETE_TEMPLATE_FAILURE = 'DELETE_TEMPLATE_FAILURE';

export const ADD_TEMPLATE_VALUE = 'ADD_TEMPLATE_VALUE';
export const SET_TEMPLATE_VALUE = 'SET_TEMPLATE_VALUE';
export const CLEAR_TEMPLATE_VALUE = 'CLEAR_TEMPLATE_VALUE';

export const SET_CLAIM_LINK_BUILDER_DRAFT = 'SET_CLAIM_LINK_BUILDER_DRAFT';
export const UPDATE_CLAIM_LINK_BUILDER_FIELD = 'UPDATE_CLAIM_LINK_BUILDER_FIELD';
export const UPDATE_ACTIVE_PAGE = 'UPDATE_ACTIVE_PAGE';
export const CLEAR_CLAIM_LINK_BUILDER_DRAFT = 'CLEAR_CLAIM_LINK_BUILDER_DRAFT';
export const SYNC_BLUEPRINT_TO_TEMPLATE_DRAFT = 'SYNC_BLUEPRINT_TO_TEMPLATE_DRAFT';

export const SET_TEMPLATE_VALIDATION_ERRORS = 'SET_TEMPLATE_VALIDATION_ERRORS';
export const SET_TEMPLATE_VALIDATION_MODAL = 'SET_TEMPLATE_VALIDATION_MODAL';
export const CLEAR_TEMPLATE_VALIDATION = 'CLEAR_TEMPLATE_VALIDATION';

export const UNDO_TEMPLATE_BUILDER_CHANGE = 'UNDO_TEMPLATE_BUILDER_CHANGE';
export const REDO_TEMPLATE_BUILDER_CHANGE = 'REDO_TEMPLATE_BUILDER_CHANGE';

export const fetchEmailsTemplatesRequest = () => ({
  type: FETCH_EMAILS_TEMPLATES_REQUEST,
});

export const fetchEmailsTemplatesSuccess = (payload: any[]) => ({
  type: FETCH_EMAILS_TEMPLATES_SUCCESS,
  payload,
});

export const fetchEmailsTemplatesFailure = (payload: any) => ({
  type: FETCH_EMAILS_TEMPLATES_FAILURE,
  payload,
});

export const fetchNotesTemplatesRequest = () => ({
  type: FETCH_NOTES_TEMPLATES_REQUEST,
});

export const fetchNotesTemplatesSuccess = (payload: any[]) => ({
  type: FETCH_NOTES_TEMPLATES_SUCCESS,
  payload,
});

export const fetchNotesTemplatesFailure = (payload: any) => ({
  type: FETCH_NOTES_TEMPLATES_FAILURE,
  payload,
});

export const addTemplateRequest = (payload: IAddTemplateRequest) => ({
  type: ADD_TEMPLATE_REQUEST,
  payload,
});

export const addTemplateSuccess = (payload?: any) => ({
  type: ADD_TEMPLATE_SUCCESS,
  payload,
});

export const addTemplateFailure = (payload?: any) => ({
  type: ADD_TEMPLATE_FAILURE,
  payload,
});

export const editTemplateRequest = (payload: IEditTemplateRequest) => ({
  type: EDIT_TEMPLATE_REQUEST,
  payload,
});

export const editTemplateSuccess = (payload?: any) => ({
  type: EDIT_TEMPLATE_SUCCESS,
  payload,
});

export const editTemplateFailure = (payload?: any) => ({
  type: EDIT_TEMPLATE_FAILURE,
  payload,
});

export const addTemplateValue = (payload?: Partial<TCollectiveTemplateItem>) => ({
  type: ADD_TEMPLATE_VALUE,
  payload,
});

export const deleteTemplateRequest = (payload: {
  itemId: string;
  type: TemplateTypesEnum | null | undefined;
  resolve: any;
  reject: any;
}) => ({
  type: DELETE_TEMPLATE_REQUEST,
  payload,
});

export const deleteTemplateSuccess = (payload: { itemId: string; type?: TemplateTypesEnum | null }) => ({
  type: DELETE_TEMPLATE_SUCCESS,
  payload,
});

export const deleteTemplateFailure = (payload?: any) => ({
  type: DELETE_TEMPLATE_FAILURE,
  payload,
});

export const setTemplateValue = (payload?: Partial<TCollectiveTemplateItem>) => ({
  type: SET_TEMPLATE_VALUE,
  payload,
});

export const clearTemplateValue = () => ({
  type: CLEAR_TEMPLATE_VALUE,
});

export const setClaimLinkBuilderDraft = (payload: IClaimLinkBuilderValues | null) => ({
  type: SET_CLAIM_LINK_BUILDER_DRAFT,
  payload,
});

export const updateClaimLinkBuilderField = (payload: IClaimLinkBuilderFieldUpdate) => ({
  type: UPDATE_CLAIM_LINK_BUILDER_FIELD,
  payload,
});

export const updateActivePage = (payload: ClaimLinkEditorPageEnum) => ({
  type: UPDATE_ACTIVE_PAGE,
  payload,
});

export const clearClaimLinkBuilderDraft = () => ({
  type: CLEAR_CLAIM_LINK_BUILDER_DRAFT,
});

export const fetchClaimLinkTemplatesRequest = (payload: IFetchClaimLinkTemplatesPayload) => ({
  type: FETCH_CLAIM_LINK_TEMPLATES_REQUEST,
  payload,
});

export const fetchClaimLinkTemplatesSuccess = (payload: IFetchClaimLinkTemplatesResponse) => ({
  type: FETCH_CLAIM_LINK_TEMPLATES_SUCCESS,
  payload,
});

export const fetchClaimLinkTemplatesFailure = (payload: unknown) => ({
  type: FETCH_CLAIM_LINK_TEMPLATES_FAILURE,
  payload,
});

export const updateClaimLinkTemplateDetailsRequest = (payload: IUpdateClaimLinkTemplateDetailsRequest) => ({
  type: UPDATE_CLAIM_LINK_TEMPLATE_DETAILS_REQUEST,
  payload,
});

export const updateClaimLinkTemplateDetailsSuccess = (payload: Partial<IClaimLinkTemplate>) => ({
  type: UPDATE_CLAIM_LINK_TEMPLATE_DETAILS_SUCCESS,
  payload,
});

export const updateClaimLinkTemplateDetailsFailure = (payload: any) => ({
  type: UPDATE_CLAIM_LINK_TEMPLATE_DETAILS_FAILURE,
  payload,
});

export const syncBlueprintToTemplateDraft = (payload: Partial<IClaimLinkTemplate>) => ({
  type: SYNC_BLUEPRINT_TO_TEMPLATE_DRAFT,
  payload,
});

export const addClaimLinkTemplateRequest = (payload: ISaveClaimLinkTemplateRequest) => ({
  type: ADD_CLAIM_LINK_TEMPLATE_REQUEST,
  payload,
});

export const addClaimLinkTemplateSuccess = (payload: ICreateClaimLinkTemplateResponse) => ({
  type: ADD_CLAIM_LINK_TEMPLATE_SUCCESS,
  payload,
});

export const addClaimLinkTemplateFailure = (payload: any) => ({
  type: ADD_CLAIM_LINK_TEMPLATE_FAILURE,
  payload,
});

export const editClaimLinkTemplateRequest = (payload: ISaveClaimLinkTemplateRequest) => ({
  type: EDIT_CLAIM_LINK_TEMPLATE_REQUEST,
  payload,
});

export const editClaimLinkTemplateSuccess = (payload: IClaimLinkTemplate) => ({
  type: EDIT_CLAIM_LINK_TEMPLATE_SUCCESS,
  payload,
});

export const editClaimLinkTemplateFailure = (payload: any) => ({
  type: EDIT_CLAIM_LINK_TEMPLATE_FAILURE,
  payload,
});

export const setTemplateValidationErrors = (payload: { errors: IClaimLinkTemplateErrors; message: string }) => ({
  type: SET_TEMPLATE_VALIDATION_ERRORS,
  payload,
});

export const setTemplateValidationModal = (payload: TemplateValidationModalEnum) => ({
  type: SET_TEMPLATE_VALIDATION_MODAL,
  payload,
});

export const clearTemplateValidation = () => ({
  type: CLEAR_TEMPLATE_VALIDATION,
});

export const undoTemplateBuilderChange = (pageId: ClaimLinkEditorPageEnum) => ({
  type: UNDO_TEMPLATE_BUILDER_CHANGE,
  payload: pageId,
});

export const redoTemplateBuilderChange = (pageId: ClaimLinkEditorPageEnum) => ({
  type: REDO_TEMPLATE_BUILDER_CHANGE,
  payload: pageId,
});

export const setClaimLinkTemplateSaving = (payload: boolean) => ({
  type: SET_CLAIM_LINK_TEMPLATE_SAVING,
  payload,
});

export const fetchClaimLinkTemplateByIdRequest = (payload: { id: string }) => ({
  type: FETCH_CLAIM_LINK_TEMPLATE_BY_ID_REQUEST,
  payload,
});

export const fetchClaimLinkTemplateByIdSuccess = (payload: IClaimLinkTemplate) => ({
  type: FETCH_CLAIM_LINK_TEMPLATE_BY_ID_SUCCESS,
  payload,
});

export const fetchClaimLinkTemplateByIdFailure = (payload: any) => ({
  type: FETCH_CLAIM_LINK_TEMPLATE_BY_ID_FAILURE,
  payload,
});
